import {
  SetGlobalErrorAction,
  ClearGlobalErrorAction,
  GlobalErrorActionTypes,
} from 'store/types/globalError'

export const setGlobalErrorAction = (
  message: string
): SetGlobalErrorAction => ({
  type: GlobalErrorActionTypes.SET_ERROR,
  payload: message,
})

export const clearGlobalErrorAction = (): ClearGlobalErrorAction => ({
  type: GlobalErrorActionTypes.CLEAR_ERROR,
})
